/** Everything §3's gate reads, from the provider and from `SessionView`. */
export type HearAgainState = {
  /** The server's turn state, lowercased, as `SessionView` holds it. */
  state: string;
  ready: boolean;
  dead: string | null;
  closing: boolean;
  ended: boolean;
  /** A press is down. */
  holding: boolean;
  micOpening: boolean;
  autoCapturing: boolean;
  /** The queue is silent and holds a whole reply (`PlaybackQueue.hasReply`). */
  replayable: boolean;
};

/**
 * When a tap on the tutor replays its last line (hear-again design §3). Only
 * at rest: never over the greeting, a reply still arriving, `thinking`, or a
 * learner mid-utterance.
 *
 * `needs_repeat` is at rest too (§1): the child who did not understand is
 * exactly who a replay serves, and no turn runs after that state's `TtsDone`,
 * so a replay still overlaps nothing the server is doing (§2).
 */
export function canHearAgain(s: HearAgainState): boolean {
  return (
    (s.state === 'idle' || s.state === 'needs_repeat') &&
    s.ready &&
    s.dead === null &&
    !s.closing &&
    !s.ended &&
    !s.holding &&
    !s.micOpening &&
    !s.autoCapturing &&
    s.replayable
  );
}
